import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Candle } from "@/components/Candle";
import { XCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="flex h-[100dvh] flex-col items-center justify-center bg-black px-6 text-center">
      <Candle progress={0.2} extinguished size={260} />
      <XCircle className="mt-4 text-muted-foreground" size={34} />
      <p className="mt-3 font-medium">{t("payment.cancelled")}</p>
      <p className="text-sm text-muted-foreground">{t("payment.noCharge")}</p>
      <Button className="mt-5 rounded-full" onClick={() => navigate("/mes-bougies")} data-testid="back-btn">
        {t("payment.backToCandles")}
      </Button>
    </div>
  );
}
